import { UserProfile } from './UserProfile';
export class FbTipsterInfo extends UserProfile {

  subscriberType: number;
  packageBuyerCount: number;
  betAmount: number;
  tipsPackagePrice: number;
  biographyDetail: string;

  constructor(id: number, nickname: string, rank: number, score: number, profitability: number,
      accuracy: number, win: number, lose: number, subscribeType: number, accuracyRanking: number,
      profitabilityRanking: number, last7DaysAccuracyRanking: number,
      last7DaysProfitabilityRanking: number, profit: number, last7DaysProfit: number,
      profitRanking: number, last7DaysProfitRanking: number,
      last7DaysProfitability: number, last7DaysAccuracy: number, subscriberType: number,
      packageBuyerCount: number, betAmount: number, tipsPackagePrice: number,
      biographyDetail: string, highestScore: number, allowVoucherBuyPackage: boolean, allowTipsPackageRefund: boolean) {
   super(id, nickname, rank, score, profitability, accuracy, win, lose, subscribeType,
      accuracyRanking, profitabilityRanking, last7DaysAccuracyRanking,
      last7DaysProfitabilityRanking, profit, last7DaysProfit, profitRanking,
      last7DaysProfitRanking, last7DaysProfitability, last7DaysAccuracy, highestScore,
      allowVoucherBuyPackage, allowTipsPackageRefund);
    this.subscriberType = subscriberType;
    this.packageBuyerCount = packageBuyerCount;
    this.betAmount = betAmount;
    this.tipsPackagePrice = tipsPackagePrice;
    this.biographyDetail = biographyDetail;
  }

  isSubscribe(): boolean {
    return this.subscribeType == 1;
  }

  getFormatRank(): string {
    return this.rank == 99999999 ? "-" : this.rank.toString();
  }

  isSubscribed(): boolean {
    return this.subscriberType == 1;
  }

  copy(userProfile: FbTipsterInfo) {
    this.id = userProfile.id;
    this.nickname = userProfile.nickname;
    this.rank = userProfile.rank;
    this.score = userProfile.score;
    this.profitability = userProfile.profitability;
    this.accuracy = userProfile.accuracy;
    this.win = userProfile.win;
    this.lose = userProfile.lose;
    this.subscribeType = userProfile.subscribeType;
    this.accuracyRanking = userProfile.accuracyRanking;
    this.profitabilityRanking = userProfile.profitabilityRanking;
    this.last7DaysAccuracyRanking = userProfile.last7DaysAccuracyRanking;
    this.last7DaysProfitabilityRanking = userProfile.last7DaysProfitabilityRanking;
    this.profit = userProfile.profit;
    this.last7DaysProfit = userProfile.last7DaysProfit;
    this.profitRanking = userProfile.profitRanking;
    this.last7DaysProfitRanking = userProfile.last7DaysProfitRanking;
    this.last7DaysProfitability = userProfile.last7DaysProfitability;
    this.last7DaysAccuracy = userProfile.last7DaysAccuracy;
    this.subscriberType = userProfile.subscriberType;
    this.packageBuyerCount = userProfile.packageBuyerCount;
    this.betAmount = userProfile.betAmount;
    this.tipsPackagePrice = userProfile.tipsPackagePrice;
    this.biographyDetail = userProfile.biographyDetail;
    this.highestScore = userProfile.highestScore;
    this.allowVoucherBuyPackage = userProfile.allowVoucherBuyPackage;
    this.allowTipsPackageRefund = userProfile.allowTipsPackageRefund;
  }


}



// WEBPACK FOOTER //
// ./src/model/FbTipsterInfo.ts